/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AutomationJobTriggerReq } from '../models';
// @ts-ignore
import type { AutomationJobTriggerRes } from '../models';
// @ts-ignore
import type { AutomationPollRes } from '../models';
// @ts-ignore
import type { BatchEligibilityHistoryQueryModel } from '../models';
// @ts-ignore
import type { BatchEligibilityResubmitCreateModel } from '../models';
// @ts-ignore
import type { BatchEligibilityResubmitQueryModel } from '../models';
// @ts-ignore
import type { BatchExportRequestParams } from '../models';
// @ts-ignore
import type { BatchTransactionResponseModel } from '../models';
// @ts-ignore
import type { BatchUploadEligibilityModel } from '../models';
// @ts-ignore
import type { BatchUploadEligibilityPatchModel } from '../models';
// @ts-ignore
import type { ClaimDetail } from '../models';
// @ts-ignore
import type { ClaimSearch } from '../models';
// @ts-ignore
import type { ClaimStatusRequest } from '../models';
// @ts-ignore
import type { ClaimsList } from '../models';
// @ts-ignore
import type { EligibilityRequest } from '../models';
// @ts-ignore
import type { EligibilityRequestQueryModel } from '../models';
// @ts-ignore
import type { EligibilityResponse } from '../models';
// @ts-ignore
import type { EligibilityResponseList } from '../models';
// @ts-ignore
import type { GetBatchEligibilityRequest200Response } from '../models';
// @ts-ignore
import type { GetBatchEligibilityRequests200Response } from '../models';
// @ts-ignore
import type { GetEligibilityRequests200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PaginatedResubmitEligibilityResponseList } from '../models';
// @ts-ignore
import type { PatchBatchUploadResponseModel } from '../models';
// @ts-ignore
import type { PostBatchUploadResponseModel } from '../models';
/**
 * EzapiApi - axios parameter creator
 * @export
 */
export const EzapiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBatchEligibilityRequest: async (batchId: string, reason: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('cancelBatchEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'reason' is not null or undefined
            assertParamExists('cancelBatchEligibilityRequest', 'reason', reason)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/status/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers payer portal scrape job for an eligibility response.
         * @summary Trigger payer portal scrape job
         * @param {string} entityId 
         * @param {AutomationJobTriggerReq} automationJobTriggerReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParsePayerPortalJob: async (entityId: string, automationJobTriggerReq: AutomationJobTriggerReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('createParsePayerPortalJob', 'entityId', entityId)
            // verify required parameter 'automationJobTriggerReq' is not null or undefined
            assertParamExists('createParsePayerPortalJob', 'automationJobTriggerReq', automationJobTriggerReq)
            const localVarPath = `/api/v1/ezapi/eligibility/responses/{entityId}/payerPortal`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automationJobTriggerReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchExportRequestParams} batchExportRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBatchEligibilityRequests: async (batchId: string, batchExportRequestParams: BatchExportRequestParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('downloadBatchEligibilityRequests', 'batchId', batchId)
            // verify required parameter 'batchExportRequestParams' is not null or undefined
            assertParamExists('downloadBatchEligibilityRequests', 'batchExportRequestParams', batchExportRequestParams)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history/{batchId}/export`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchExportRequestParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {ClaimSearch} claimSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimStatusRequest: async (claimSearch: ClaimSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimSearch' is not null or undefined
            assertParamExists('exportClaimStatusRequest', 'claimSearch', claimSearch)
            const localVarPath = `/api/v1/ezapi/claimStatus/responses/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEligibilityRequest: async (eligibilityRequestQueryModel: EligibilityRequestQueryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequestQueryModel' is not null or undefined
            assertParamExists('exportEligibilityRequest', 'eligibilityRequestQueryModel', eligibilityRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/eligibility/responses/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequest: async (batchId: string, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getBatchEligibilityRequest', 'batchId', batchId)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequests: async (batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityHistoryQueryModel' is not null or undefined
            assertParamExists('getBatchEligibilityRequests', 'batchEligibilityHistoryQueryModel', batchEligibilityHistoryQueryModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityHistoryQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchHeaderMapping: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getBatchHeaderMapping', 'requestBody', requestBody)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/headerMapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequest: async (batchId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getBatchUploadEligibilityRequest', 'batchId', batchId)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequestTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusResponseByID: async (responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getClaimStatusResponseByID', 'responseId', responseId)
            const localVarPath = `/api/v1/ezapi/claimStatus/responses/{response_id}`
                .replace(`{${"response_id"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityRequests: async (eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequestQueryModel' is not null or undefined
            assertParamExists('getEligibilityRequests', 'eligibilityRequestQueryModel', eligibilityRequestQueryModel)
            const localVarPath = `/api/v1/ezapi/eligibility/responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequestQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityResponseByID: async (responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('getEligibilityResponseByID', 'responseId', responseId)
            const localVarPath = `/api/v1/ezapi/eligibility/responses/{response_id}`
                .replace(`{${"response_id"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payer portal scrape job status and result
         * @summary Get payer portal scrape job status and result
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsePayerPortalJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getParsePayerPortalJob', 'jobId', jobId)
            const localVarPath = `/api/v1/ezapi/eligibility/payerPortal/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequest: async (batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'batchUploadEligibilityPatchModel' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequest', 'batchUploadEligibilityPatchModel', batchUploadEligibilityPatchModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUploadEligibilityPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequestMapping: async (batchId: string, requestBody: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequestMapping', 'batchId', batchId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('patchBatchUploadEligibilityRequestMapping', 'requestBody', requestBody)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}/mapping`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchResubmitEligibilityRequest: async (batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityResubmitCreateModel' is not null or undefined
            assertParamExists('postBatchResubmitEligibilityRequest', 'batchEligibilityResubmitCreateModel', batchEligibilityResubmitCreateModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/resubmit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityResubmitCreateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {BatchUploadEligibilityModel} uploadModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchUploadEligibilityRequest: async (file: File, uploadModel: BatchUploadEligibilityModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('postBatchUploadEligibilityRequest', 'file', file)
            // verify required parameter 'uploadModel' is not null or undefined
            assertParamExists('postBatchUploadEligibilityRequest', 'uploadModel', uploadModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (uploadModel !== undefined) { 
                localVarFormParams.append('uploadModel', new Blob([JSON.stringify(uploadModel)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {Array<ClaimStatusRequest>} claimStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusRequests: async (claimStatusRequest: Array<ClaimStatusRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimStatusRequest' is not null or undefined
            assertParamExists('postClaimStatusRequests', 'claimStatusRequest', claimStatusRequest)
            const localVarPath = `/api/v1/ezapi/claimStatus/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * resubmit claim status request
         * @summary resubmit claim status requests with claim id
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusResubmitRequest: async (claimId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimId' is not null or undefined
            assertParamExists('postClaimStatusResubmitRequest', 'claimId', claimId)
            const localVarPath = `/api/v1/ezapi/claimStatus/resubmit/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEligibilityRequests: async (eligibilityRequest: Array<EligibilityRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eligibilityRequest' is not null or undefined
            assertParamExists('postEligibilityRequests', 'eligibilityRequest', eligibilityRequest)
            const localVarPath = `/api/v1/ezapi/eligibility/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * post eligibility requests for a specific coverage
         * @summary post patient-based eligibility requests
         * @param {string} coverageId 
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPatientBasedEligibilityRequests: async (coverageId: string, eligibilityRequest: Array<EligibilityRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverageId' is not null or undefined
            assertParamExists('postPatientBasedEligibilityRequests', 'coverageId', coverageId)
            // verify required parameter 'eligibilityRequest' is not null or undefined
            assertParamExists('postPatientBasedEligibilityRequests', 'eligibilityRequest', eligibilityRequest)
            const localVarPath = `/api/v1/ezapi/eligibility/requests/coverage/{coverageId}`
                .replace(`{${"coverageId"}}`, encodeURIComponent(String(coverageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eligibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBatchResubmitEligibilityRequest: async (batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchEligibilityResubmitQueryModel' is not null or undefined
            assertParamExists('validateBatchResubmitEligibilityRequest', 'batchEligibilityResubmitQueryModel', batchEligibilityResubmitQueryModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/resubmit/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchEligibilityResubmitQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatchBatchUploadEligibilityRequest: async (batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('validatePatchBatchUploadEligibilityRequest', 'batchId', batchId)
            // verify required parameter 'batchUploadEligibilityPatchModel' is not null or undefined
            assertParamExists('validatePatchBatchUploadEligibilityRequest', 'batchUploadEligibilityPatchModel', batchUploadEligibilityPatchModel)
            const localVarPath = `/api/v1/ezapi/batch/eligibility/upload/{batchId}/validate`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchUploadEligibilityPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EzapiApi - functional programming interface
 * @export
 */
export const EzapiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EzapiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {string} reason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBatchEligibilityRequest(batchId: string, reason: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBatchEligibilityRequest(batchId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.cancelBatchEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers payer portal scrape job for an eligibility response.
         * @summary Trigger payer portal scrape job
         * @param {string} entityId 
         * @param {AutomationJobTriggerReq} automationJobTriggerReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createParsePayerPortalJob(entityId: string, automationJobTriggerReq: AutomationJobTriggerReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutomationJobTriggerRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createParsePayerPortalJob(entityId, automationJobTriggerReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.createParsePayerPortalJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchExportRequestParams} batchExportRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBatchEligibilityRequests(batchId: string, batchExportRequestParams: BatchExportRequestParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBatchEligibilityRequests(batchId, batchExportRequestParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.downloadBatchEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {ClaimSearch} claimSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportClaimStatusRequest(claimSearch: ClaimSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportClaimStatusRequest(claimSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.exportClaimStatusRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportEligibilityRequest(eligibilityRequestQueryModel: EligibilityRequestQueryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportEligibilityRequest(eligibilityRequestQueryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.exportEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchEligibilityRequest(batchId: string, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBatchEligibilityRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchEligibilityRequest(batchId, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityHistoryQueryModel} batchEligibilityHistoryQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchEligibilityRequests(batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBatchEligibilityRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchEligibilityRequests(batchEligibilityHistoryQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchHeaderMapping(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchHeaderMapping(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchHeaderMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchUploadEligibilityRequest(batchId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchUploadEligibilityRequest(batchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchUploadEligibilityRequestTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getBatchUploadEligibilityRequestTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimStatusResponseByID(responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimStatusResponseByID(responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getClaimStatusResponseByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EligibilityRequestQueryModel} eligibilityRequestQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibilityRequests(eligibilityRequestQueryModel: EligibilityRequestQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEligibilityRequests200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibilityRequests(eligibilityRequestQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibilityResponseByID(responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibilityResponseByID(responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getEligibilityResponseByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get payer portal scrape job status and result
         * @summary Get payer portal scrape job status and result
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParsePayerPortalJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutomationPollRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParsePayerPortalJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.getParsePayerPortalJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.patchBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBatchUploadEligibilityRequestMapping(batchId: string, requestBody: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBatchUploadEligibilityRequestMapping(batchId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.patchBatchUploadEligibilityRequestMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityResubmitCreateModel} batchEligibilityResubmitCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchTransactionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBatchResubmitEligibilityRequest(batchEligibilityResubmitCreateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postBatchResubmitEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} file 
         * @param {BatchUploadEligibilityModel} uploadModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBatchUploadEligibilityRequest(file: File, uploadModel: BatchUploadEligibilityModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBatchUploadEligibilityRequest(file, uploadModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {Array<ClaimStatusRequest>} claimStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimStatusRequests(claimStatusRequest: Array<ClaimStatusRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimsList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimStatusRequests(claimStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postClaimStatusRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * resubmit claim status request
         * @summary resubmit claim status requests with claim id
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClaimStatusResubmitRequest(claimId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimsList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClaimStatusResubmitRequest(claimId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postClaimStatusResubmitRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEligibilityRequests(eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EligibilityResponseList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEligibilityRequests(eligibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * post eligibility requests for a specific coverage
         * @summary post patient-based eligibility requests
         * @param {string} coverageId 
         * @param {Array<EligibilityRequest>} eligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPatientBasedEligibilityRequests(coverageId: string, eligibilityRequest: Array<EligibilityRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EligibilityResponseList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPatientBasedEligibilityRequests(coverageId, eligibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.postPatientBasedEligibilityRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchEligibilityResubmitQueryModel} batchEligibilityResubmitQueryModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResubmitEligibilityResponseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBatchResubmitEligibilityRequest(batchEligibilityResubmitQueryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.validateBatchResubmitEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {BatchUploadEligibilityPatchModel} batchUploadEligibilityPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePatchBatchUploadEligibilityRequest(batchId: string, batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchBatchUploadResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePatchBatchUploadEligibilityRequest(batchId, batchUploadEligibilityPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EzapiApi.validatePatchBatchUploadEligibilityRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EzapiApi - factory interface
 * @export
 */
export const EzapiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EzapiApiFp(configuration)
    return {
        /**
         * 
         * @param {EzapiApiCancelBatchEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBatchEligibilityRequest(requestParameters: EzapiApiCancelBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelBatchEligibilityRequest(requestParameters.batchId, requestParameters.reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers payer portal scrape job for an eligibility response.
         * @summary Trigger payer portal scrape job
         * @param {EzapiApiCreateParsePayerPortalJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createParsePayerPortalJob(requestParameters: EzapiApiCreateParsePayerPortalJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutomationJobTriggerRes> {
            return localVarFp.createParsePayerPortalJob(requestParameters.entityId, requestParameters.automationJobTriggerReq, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiDownloadBatchEligibilityRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBatchEligibilityRequests(requestParameters: EzapiApiDownloadBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.downloadBatchEligibilityRequests(requestParameters.batchId, requestParameters.batchExportRequestParams, options).then((request) => request(axios, basePath));
        },
        /**
         * API to export the exiting claim status request data between start date and end date in .xslx format
         * @summary export existing claim status request data
         * @param {EzapiApiExportClaimStatusRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportClaimStatusRequest(requestParameters: EzapiApiExportClaimStatusRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportClaimStatusRequest(requestParameters.claimSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * API to export the exiting eligibility request data between start date and end date in .xslx format
         * @summary export existing eligibilityrequest data
         * @param {EzapiApiExportEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEligibilityRequest(requestParameters: EzapiApiExportEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportEligibilityRequest(requestParameters.eligibilityRequestQueryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiGetBatchEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequest(requestParameters: EzapiApiGetBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequest200Response> {
            return localVarFp.getBatchEligibilityRequest(requestParameters.batchId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiGetBatchEligibilityRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchEligibilityRequests(requestParameters: EzapiApiGetBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequests200Response> {
            return localVarFp.getBatchEligibilityRequests(requestParameters.batchEligibilityHistoryQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiGetBatchHeaderMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchHeaderMapping(requestParameters: EzapiApiGetBatchHeaderMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getBatchHeaderMapping(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiGetBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequest(requestParameters: EzapiApiGetBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.getBatchUploadEligibilityRequest(requestParameters.batchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getBatchUploadEligibilityRequestTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * API to get the claimstatus request reponse and data
         * @summary Get data for Claim Status Response given ID
         * @param {EzapiApiGetClaimStatusResponseByIDRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimStatusResponseByID(requestParameters: EzapiApiGetClaimStatusResponseByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimDetail> {
            return localVarFp.getClaimStatusResponseByID(requestParameters.responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * get eligibility request data
         * @summary Get paginated data for a Eligibility Requests
         * @param {EzapiApiGetEligibilityRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityRequests(requestParameters: EzapiApiGetEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEligibilityRequests200Response> {
            return localVarFp.getEligibilityRequests(requestParameters.eligibilityRequestQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get the eligibility request status and data
         * @summary Get data for a Eligibility request
         * @param {EzapiApiGetEligibilityResponseByIDRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibilityResponseByID(requestParameters: EzapiApiGetEligibilityResponseByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityResponse> {
            return localVarFp.getEligibilityResponseByID(requestParameters.responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get payer portal scrape job status and result
         * @summary Get payer portal scrape job status and result
         * @param {EzapiApiGetParsePayerPortalJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsePayerPortalJob(requestParameters: EzapiApiGetParsePayerPortalJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutomationPollRes> {
            return localVarFp.getParsePayerPortalJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiPatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequest(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.patchBatchUploadEligibilityRequest(requestParameters.batchId, requestParameters.batchUploadEligibilityPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiPatchBatchUploadEligibilityRequestMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBatchUploadEligibilityRequestMapping(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.patchBatchUploadEligibilityRequestMapping(requestParameters.batchId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiPostBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchResubmitEligibilityRequest(requestParameters: EzapiApiPostBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchTransactionResponseModel> {
            return localVarFp.postBatchResubmitEligibilityRequest(requestParameters.batchEligibilityResubmitCreateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiPostBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBatchUploadEligibilityRequest(requestParameters: EzapiApiPostBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostBatchUploadResponseModel> {
            return localVarFp.postBatchUploadEligibilityRequest(requestParameters.file, requestParameters.uploadModel, options).then((request) => request(axios, basePath));
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
         * @summary post claim status requests
         * @param {EzapiApiPostClaimStatusRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusRequests(requestParameters: EzapiApiPostClaimStatusRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimsList>> {
            return localVarFp.postClaimStatusRequests(requestParameters.claimStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * resubmit claim status request
         * @summary resubmit claim status requests with claim id
         * @param {EzapiApiPostClaimStatusResubmitRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClaimStatusResubmitRequest(requestParameters: EzapiApiPostClaimStatusResubmitRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimsList>> {
            return localVarFp.postClaimStatusResubmitRequest(requestParameters.claimId, options).then((request) => request(axios, basePath));
        },
        /**
         * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
         * @summary post eligibility requests
         * @param {EzapiApiPostEligibilityRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEligibilityRequests(requestParameters: EzapiApiPostEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>> {
            return localVarFp.postEligibilityRequests(requestParameters.eligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * post eligibility requests for a specific coverage
         * @summary post patient-based eligibility requests
         * @param {EzapiApiPostPatientBasedEligibilityRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPatientBasedEligibilityRequests(requestParameters: EzapiApiPostPatientBasedEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>> {
            return localVarFp.postPatientBasedEligibilityRequests(requestParameters.coverageId, requestParameters.eligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiValidateBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBatchResubmitEligibilityRequest(requestParameters: EzapiApiValidateBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResubmitEligibilityResponseList> {
            return localVarFp.validateBatchResubmitEligibilityRequest(requestParameters.batchEligibilityResubmitQueryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EzapiApiValidatePatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePatchBatchUploadEligibilityRequest(requestParameters: EzapiApiValidatePatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel> {
            return localVarFp.validatePatchBatchUploadEligibilityRequest(requestParameters.batchId, requestParameters.batchUploadEligibilityPatchModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EzapiApi - interface
 * @export
 * @interface EzapiApi
 */
export interface EzapiApiInterface {
    /**
     * 
     * @param {EzapiApiCancelBatchEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    cancelBatchEligibilityRequest(requestParameters: EzapiApiCancelBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Triggers payer portal scrape job for an eligibility response.
     * @summary Trigger payer portal scrape job
     * @param {EzapiApiCreateParsePayerPortalJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    createParsePayerPortalJob(requestParameters: EzapiApiCreateParsePayerPortalJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutomationJobTriggerRes>;

    /**
     * 
     * @param {EzapiApiDownloadBatchEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    downloadBatchEligibilityRequests(requestParameters: EzapiApiDownloadBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * API to export the exiting claim status request data between start date and end date in .xslx format
     * @summary export existing claim status request data
     * @param {EzapiApiExportClaimStatusRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    exportClaimStatusRequest(requestParameters: EzapiApiExportClaimStatusRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * API to export the exiting eligibility request data between start date and end date in .xslx format
     * @summary export existing eligibilityrequest data
     * @param {EzapiApiExportEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    exportEligibilityRequest(requestParameters: EzapiApiExportEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {EzapiApiGetBatchEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchEligibilityRequest(requestParameters: EzapiApiGetBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequest200Response>;

    /**
     * 
     * @param {EzapiApiGetBatchEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchEligibilityRequests(requestParameters: EzapiApiGetBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBatchEligibilityRequests200Response>;

    /**
     * 
     * @param {EzapiApiGetBatchHeaderMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchHeaderMapping(requestParameters: EzapiApiGetBatchHeaderMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }>;

    /**
     * 
     * @param {EzapiApiGetBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchUploadEligibilityRequest(requestParameters: EzapiApiGetBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * API to get the claimstatus request reponse and data
     * @summary Get data for Claim Status Response given ID
     * @param {EzapiApiGetClaimStatusResponseByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getClaimStatusResponseByID(requestParameters: EzapiApiGetClaimStatusResponseByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimDetail>;

    /**
     * get eligibility request data
     * @summary Get paginated data for a Eligibility Requests
     * @param {EzapiApiGetEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getEligibilityRequests(requestParameters: EzapiApiGetEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEligibilityRequests200Response>;

    /**
     * API to get the eligibility request status and data
     * @summary Get data for a Eligibility request
     * @param {EzapiApiGetEligibilityResponseByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getEligibilityResponseByID(requestParameters: EzapiApiGetEligibilityResponseByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityResponse>;

    /**
     * Get payer portal scrape job status and result
     * @summary Get payer portal scrape job status and result
     * @param {EzapiApiGetParsePayerPortalJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    getParsePayerPortalJob(requestParameters: EzapiApiGetParsePayerPortalJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutomationPollRes>;

    /**
     * 
     * @param {EzapiApiPatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    patchBatchUploadEligibilityRequest(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {EzapiApiPatchBatchUploadEligibilityRequestMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    patchBatchUploadEligibilityRequestMapping(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

    /**
     * 
     * @param {EzapiApiPostBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postBatchResubmitEligibilityRequest(requestParameters: EzapiApiPostBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchTransactionResponseModel>;

    /**
     * 
     * @param {EzapiApiPostBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postBatchUploadEligibilityRequest(requestParameters: EzapiApiPostBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostBatchUploadResponseModel>;

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
     * @summary post claim status requests
     * @param {EzapiApiPostClaimStatusRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postClaimStatusRequests(requestParameters: EzapiApiPostClaimStatusRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimsList>>;

    /**
     * resubmit claim status request
     * @summary resubmit claim status requests with claim id
     * @param {EzapiApiPostClaimStatusResubmitRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postClaimStatusResubmitRequest(requestParameters: EzapiApiPostClaimStatusResubmitRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClaimsList>>;

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
     * @summary post eligibility requests
     * @param {EzapiApiPostEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postEligibilityRequests(requestParameters: EzapiApiPostEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>>;

    /**
     * post eligibility requests for a specific coverage
     * @summary post patient-based eligibility requests
     * @param {EzapiApiPostPatientBasedEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    postPatientBasedEligibilityRequests(requestParameters: EzapiApiPostPatientBasedEligibilityRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EligibilityResponseList>>;

    /**
     * 
     * @param {EzapiApiValidateBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    validateBatchResubmitEligibilityRequest(requestParameters: EzapiApiValidateBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResubmitEligibilityResponseList>;

    /**
     * 
     * @param {EzapiApiValidatePatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApiInterface
     */
    validatePatchBatchUploadEligibilityRequest(requestParameters: EzapiApiValidatePatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchBatchUploadResponseModel>;

}

/**
 * Request parameters for cancelBatchEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiCancelBatchEligibilityRequestRequest
 */
export interface EzapiApiCancelBatchEligibilityRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiCancelBatchEligibilityRequest
     */
    readonly batchId: string

    /**
     * 
     * @type {string}
     * @memberof EzapiApiCancelBatchEligibilityRequest
     */
    readonly reason: string
}

/**
 * Request parameters for createParsePayerPortalJob operation in EzapiApi.
 * @export
 * @interface EzapiApiCreateParsePayerPortalJobRequest
 */
export interface EzapiApiCreateParsePayerPortalJobRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiCreateParsePayerPortalJob
     */
    readonly entityId: string

    /**
     * 
     * @type {AutomationJobTriggerReq}
     * @memberof EzapiApiCreateParsePayerPortalJob
     */
    readonly automationJobTriggerReq: AutomationJobTriggerReq
}

/**
 * Request parameters for downloadBatchEligibilityRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiDownloadBatchEligibilityRequestsRequest
 */
export interface EzapiApiDownloadBatchEligibilityRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiDownloadBatchEligibilityRequests
     */
    readonly batchId: string

    /**
     * 
     * @type {BatchExportRequestParams}
     * @memberof EzapiApiDownloadBatchEligibilityRequests
     */
    readonly batchExportRequestParams: BatchExportRequestParams
}

/**
 * Request parameters for exportClaimStatusRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiExportClaimStatusRequestRequest
 */
export interface EzapiApiExportClaimStatusRequestRequest {
    /**
     * 
     * @type {ClaimSearch}
     * @memberof EzapiApiExportClaimStatusRequest
     */
    readonly claimSearch: ClaimSearch
}

/**
 * Request parameters for exportEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiExportEligibilityRequestRequest
 */
export interface EzapiApiExportEligibilityRequestRequest {
    /**
     * 
     * @type {EligibilityRequestQueryModel}
     * @memberof EzapiApiExportEligibilityRequest
     */
    readonly eligibilityRequestQueryModel: EligibilityRequestQueryModel
}

/**
 * Request parameters for getBatchEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiGetBatchEligibilityRequestRequest
 */
export interface EzapiApiGetBatchEligibilityRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiGetBatchEligibilityRequest
     */
    readonly batchId: string

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetBatchEligibilityRequest
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetBatchEligibilityRequest
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getBatchEligibilityRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiGetBatchEligibilityRequestsRequest
 */
export interface EzapiApiGetBatchEligibilityRequestsRequest {
    /**
     * 
     * @type {BatchEligibilityHistoryQueryModel}
     * @memberof EzapiApiGetBatchEligibilityRequests
     */
    readonly batchEligibilityHistoryQueryModel: BatchEligibilityHistoryQueryModel

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetBatchEligibilityRequests
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetBatchEligibilityRequests
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getBatchHeaderMapping operation in EzapiApi.
 * @export
 * @interface EzapiApiGetBatchHeaderMappingRequest
 */
export interface EzapiApiGetBatchHeaderMappingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EzapiApiGetBatchHeaderMapping
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for getBatchUploadEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiGetBatchUploadEligibilityRequestRequest
 */
export interface EzapiApiGetBatchUploadEligibilityRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiGetBatchUploadEligibilityRequest
     */
    readonly batchId: string
}

/**
 * Request parameters for getClaimStatusResponseByID operation in EzapiApi.
 * @export
 * @interface EzapiApiGetClaimStatusResponseByIDRequest
 */
export interface EzapiApiGetClaimStatusResponseByIDRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiGetClaimStatusResponseByID
     */
    readonly responseId: string
}

/**
 * Request parameters for getEligibilityRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiGetEligibilityRequestsRequest
 */
export interface EzapiApiGetEligibilityRequestsRequest {
    /**
     * 
     * @type {EligibilityRequestQueryModel}
     * @memberof EzapiApiGetEligibilityRequests
     */
    readonly eligibilityRequestQueryModel: EligibilityRequestQueryModel

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetEligibilityRequests
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof EzapiApiGetEligibilityRequests
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getEligibilityResponseByID operation in EzapiApi.
 * @export
 * @interface EzapiApiGetEligibilityResponseByIDRequest
 */
export interface EzapiApiGetEligibilityResponseByIDRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiGetEligibilityResponseByID
     */
    readonly responseId: string
}

/**
 * Request parameters for getParsePayerPortalJob operation in EzapiApi.
 * @export
 * @interface EzapiApiGetParsePayerPortalJobRequest
 */
export interface EzapiApiGetParsePayerPortalJobRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiGetParsePayerPortalJob
     */
    readonly jobId: string
}

/**
 * Request parameters for patchBatchUploadEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiPatchBatchUploadEligibilityRequestRequest
 */
export interface EzapiApiPatchBatchUploadEligibilityRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiPatchBatchUploadEligibilityRequest
     */
    readonly batchId: string

    /**
     * 
     * @type {BatchUploadEligibilityPatchModel}
     * @memberof EzapiApiPatchBatchUploadEligibilityRequest
     */
    readonly batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel
}

/**
 * Request parameters for patchBatchUploadEligibilityRequestMapping operation in EzapiApi.
 * @export
 * @interface EzapiApiPatchBatchUploadEligibilityRequestMappingRequest
 */
export interface EzapiApiPatchBatchUploadEligibilityRequestMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiPatchBatchUploadEligibilityRequestMapping
     */
    readonly batchId: string

    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EzapiApiPatchBatchUploadEligibilityRequestMapping
     */
    readonly requestBody: { [key: string]: string; }
}

/**
 * Request parameters for postBatchResubmitEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiPostBatchResubmitEligibilityRequestRequest
 */
export interface EzapiApiPostBatchResubmitEligibilityRequestRequest {
    /**
     * 
     * @type {BatchEligibilityResubmitCreateModel}
     * @memberof EzapiApiPostBatchResubmitEligibilityRequest
     */
    readonly batchEligibilityResubmitCreateModel: BatchEligibilityResubmitCreateModel
}

/**
 * Request parameters for postBatchUploadEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiPostBatchUploadEligibilityRequestRequest
 */
export interface EzapiApiPostBatchUploadEligibilityRequestRequest {
    /**
     * 
     * @type {File}
     * @memberof EzapiApiPostBatchUploadEligibilityRequest
     */
    readonly file: File

    /**
     * 
     * @type {BatchUploadEligibilityModel}
     * @memberof EzapiApiPostBatchUploadEligibilityRequest
     */
    readonly uploadModel: BatchUploadEligibilityModel
}

/**
 * Request parameters for postClaimStatusRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiPostClaimStatusRequestsRequest
 */
export interface EzapiApiPostClaimStatusRequestsRequest {
    /**
     * 
     * @type {Array<ClaimStatusRequest>}
     * @memberof EzapiApiPostClaimStatusRequests
     */
    readonly claimStatusRequest: Array<ClaimStatusRequest>
}

/**
 * Request parameters for postClaimStatusResubmitRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiPostClaimStatusResubmitRequestRequest
 */
export interface EzapiApiPostClaimStatusResubmitRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiPostClaimStatusResubmitRequest
     */
    readonly claimId: string
}

/**
 * Request parameters for postEligibilityRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiPostEligibilityRequestsRequest
 */
export interface EzapiApiPostEligibilityRequestsRequest {
    /**
     * 
     * @type {Array<EligibilityRequest>}
     * @memberof EzapiApiPostEligibilityRequests
     */
    readonly eligibilityRequest: Array<EligibilityRequest>
}

/**
 * Request parameters for postPatientBasedEligibilityRequests operation in EzapiApi.
 * @export
 * @interface EzapiApiPostPatientBasedEligibilityRequestsRequest
 */
export interface EzapiApiPostPatientBasedEligibilityRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiPostPatientBasedEligibilityRequests
     */
    readonly coverageId: string

    /**
     * 
     * @type {Array<EligibilityRequest>}
     * @memberof EzapiApiPostPatientBasedEligibilityRequests
     */
    readonly eligibilityRequest: Array<EligibilityRequest>
}

/**
 * Request parameters for validateBatchResubmitEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiValidateBatchResubmitEligibilityRequestRequest
 */
export interface EzapiApiValidateBatchResubmitEligibilityRequestRequest {
    /**
     * 
     * @type {BatchEligibilityResubmitQueryModel}
     * @memberof EzapiApiValidateBatchResubmitEligibilityRequest
     */
    readonly batchEligibilityResubmitQueryModel: BatchEligibilityResubmitQueryModel
}

/**
 * Request parameters for validatePatchBatchUploadEligibilityRequest operation in EzapiApi.
 * @export
 * @interface EzapiApiValidatePatchBatchUploadEligibilityRequestRequest
 */
export interface EzapiApiValidatePatchBatchUploadEligibilityRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof EzapiApiValidatePatchBatchUploadEligibilityRequest
     */
    readonly batchId: string

    /**
     * 
     * @type {BatchUploadEligibilityPatchModel}
     * @memberof EzapiApiValidatePatchBatchUploadEligibilityRequest
     */
    readonly batchUploadEligibilityPatchModel: BatchUploadEligibilityPatchModel
}

/**
 * EzapiApi - object-oriented interface
 * @export
 * @class EzapiApi
 * @extends {BaseAPI}
 */
export class EzapiApi extends BaseAPI implements EzapiApiInterface {
    /**
     * 
     * @param {EzapiApiCancelBatchEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public cancelBatchEligibilityRequest(requestParameters: EzapiApiCancelBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).cancelBatchEligibilityRequest(requestParameters.batchId, requestParameters.reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers payer portal scrape job for an eligibility response.
     * @summary Trigger payer portal scrape job
     * @param {EzapiApiCreateParsePayerPortalJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public createParsePayerPortalJob(requestParameters: EzapiApiCreateParsePayerPortalJobRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).createParsePayerPortalJob(requestParameters.entityId, requestParameters.automationJobTriggerReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiDownloadBatchEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public downloadBatchEligibilityRequests(requestParameters: EzapiApiDownloadBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).downloadBatchEligibilityRequests(requestParameters.batchId, requestParameters.batchExportRequestParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to export the exiting claim status request data between start date and end date in .xslx format
     * @summary export existing claim status request data
     * @param {EzapiApiExportClaimStatusRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public exportClaimStatusRequest(requestParameters: EzapiApiExportClaimStatusRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).exportClaimStatusRequest(requestParameters.claimSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to export the exiting eligibility request data between start date and end date in .xslx format
     * @summary export existing eligibilityrequest data
     * @param {EzapiApiExportEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public exportEligibilityRequest(requestParameters: EzapiApiExportEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).exportEligibilityRequest(requestParameters.eligibilityRequestQueryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiGetBatchEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchEligibilityRequest(requestParameters: EzapiApiGetBatchEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchEligibilityRequest(requestParameters.batchId, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiGetBatchEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchEligibilityRequests(requestParameters: EzapiApiGetBatchEligibilityRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchEligibilityRequests(requestParameters.batchEligibilityHistoryQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiGetBatchHeaderMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchHeaderMapping(requestParameters: EzapiApiGetBatchHeaderMappingRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchHeaderMapping(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiGetBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchUploadEligibilityRequest(requestParameters: EzapiApiGetBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchUploadEligibilityRequest(requestParameters.batchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getBatchUploadEligibilityRequestTemplate(options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getBatchUploadEligibilityRequestTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get the claimstatus request reponse and data
     * @summary Get data for Claim Status Response given ID
     * @param {EzapiApiGetClaimStatusResponseByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getClaimStatusResponseByID(requestParameters: EzapiApiGetClaimStatusResponseByIDRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getClaimStatusResponseByID(requestParameters.responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get eligibility request data
     * @summary Get paginated data for a Eligibility Requests
     * @param {EzapiApiGetEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getEligibilityRequests(requestParameters: EzapiApiGetEligibilityRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getEligibilityRequests(requestParameters.eligibilityRequestQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get the eligibility request status and data
     * @summary Get data for a Eligibility request
     * @param {EzapiApiGetEligibilityResponseByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getEligibilityResponseByID(requestParameters: EzapiApiGetEligibilityResponseByIDRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getEligibilityResponseByID(requestParameters.responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payer portal scrape job status and result
     * @summary Get payer portal scrape job status and result
     * @param {EzapiApiGetParsePayerPortalJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public getParsePayerPortalJob(requestParameters: EzapiApiGetParsePayerPortalJobRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).getParsePayerPortalJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiPatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public patchBatchUploadEligibilityRequest(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).patchBatchUploadEligibilityRequest(requestParameters.batchId, requestParameters.batchUploadEligibilityPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiPatchBatchUploadEligibilityRequestMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public patchBatchUploadEligibilityRequestMapping(requestParameters: EzapiApiPatchBatchUploadEligibilityRequestMappingRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).patchBatchUploadEligibilityRequestMapping(requestParameters.batchId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiPostBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postBatchResubmitEligibilityRequest(requestParameters: EzapiApiPostBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postBatchResubmitEligibilityRequest(requestParameters.batchEligibilityResubmitCreateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiPostBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postBatchUploadEligibilityRequest(requestParameters: EzapiApiPostBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postBatchUploadEligibilityRequest(requestParameters.file, requestParameters.uploadModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists then validate data, update patient record and make claim status check request else validate data, create patient record, create insurancecoverage record and make claim status check request
     * @summary post claim status requests
     * @param {EzapiApiPostClaimStatusRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postClaimStatusRequests(requestParameters: EzapiApiPostClaimStatusRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postClaimStatusRequests(requestParameters.claimStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * resubmit claim status request
     * @summary resubmit claim status requests with claim id
     * @param {EzapiApiPostClaimStatusResubmitRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postClaimStatusResubmitRequest(requestParameters: EzapiApiPostClaimStatusResubmitRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postClaimStatusResubmitRequest(requestParameters.claimId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get patient info - check in insurancecoverage if payer, beneficiary, memberId relation exists if it exists:     validate data, update patient record and make eligibility request else:     validate data, create patient record, create insurancecoverage record and make eligibility request
     * @summary post eligibility requests
     * @param {EzapiApiPostEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postEligibilityRequests(requestParameters: EzapiApiPostEligibilityRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postEligibilityRequests(requestParameters.eligibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * post eligibility requests for a specific coverage
     * @summary post patient-based eligibility requests
     * @param {EzapiApiPostPatientBasedEligibilityRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public postPatientBasedEligibilityRequests(requestParameters: EzapiApiPostPatientBasedEligibilityRequestsRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).postPatientBasedEligibilityRequests(requestParameters.coverageId, requestParameters.eligibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiValidateBatchResubmitEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public validateBatchResubmitEligibilityRequest(requestParameters: EzapiApiValidateBatchResubmitEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).validateBatchResubmitEligibilityRequest(requestParameters.batchEligibilityResubmitQueryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EzapiApiValidatePatchBatchUploadEligibilityRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EzapiApi
     */
    public validatePatchBatchUploadEligibilityRequest(requestParameters: EzapiApiValidatePatchBatchUploadEligibilityRequestRequest, options?: RawAxiosRequestConfig) {
        return EzapiApiFp(this.configuration).validatePatchBatchUploadEligibilityRequest(requestParameters.batchId, requestParameters.batchUploadEligibilityPatchModel, options).then((request) => request(this.axios, this.basePath));
    }
}

